import React from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import MainRoutes from './routes/MainRoutes';
import { useLocation } from 'react-router-dom';


const AppRoutes = () => {
  const location = useLocation();
  const hideLayoutRoutes = ["/xeokit-viewer"];

  return (
    <>
      {/* Navbar displayed on all pages */}
      {!hideLayoutRoutes.includes(location.pathname) && <Navbar />}

      {/* Define all routes */}
      <MainRoutes />

      {/* Footer will be displayed on all pages */}
      {!hideLayoutRoutes.includes(location.pathname) && <Footer />}
    </>
  );
};

export default AppRoutes;